<template>
  <v-text-field
    v-if="textarea"
    :disabled="disabled !== false"
    :type="type"
    :label="label"
    :readonly="readonly"
    :placeholder="placeholder === undefined ? 'N/A' : placeholder"
    :prepend-icon="icon || prependIcon"
    :value="value_"
    persistent-hint
    :hint="hint"
  ></v-text-field>
  <v-textarea
    v-else
    :rows="1"
    auto-grow
    :readonly="readonly"
    :disabled="disabled !== false"
    :label="label"
    :placeholder="placeholder === undefined ? 'N/A' : placeholder"
    :prepend-icon="icon || prependIcon"
    :value="value_"
    persistent-hint
    :hint="hint"
  ></v-textarea>
</template>

<script>
export default {
  name: 'infoCell',
  props: [
    'textarea',
    'value',
    'icon',
    'label',
    'type',
    'placeholder',
    'prependIcon',
    'hint',
    'readonly',
    'disabled',
    'f',
  ],
  computed: {
    value_ () {
      if (this.f instanceof Function) {
        return this.f(this.value)
      }
      else {
        return this.value
      }
    },

  },
}
</script>
